import { ButtonRow } from '@cb/apricot-react'

function ModalFooter({ actions = [] }) {
  if (actions.length > 0) {
    return (
      <div className="cb-modal-footer">
        <ButtonRow>
          {actions.map((Action, index) => (
            <Action key={index} />
          ))}
        </ButtonRow>
      </div>
    )
  }

  return null
}

export default ModalFooter
